import React, { useState } from "react";

import { useDropzone } from "react-dropzone";

import Sidebar from "../Sidebar";

import TopNavbar from "../../top-navbar/TopNav";

import axios from "axios";

import jsPDF from "jspdf";

import autoTable from "jspdf-autotable";

import "./DocumentUpload.css";
 
const DocumentUpload = () => {

  const [selectedFile, setSelectedFile] = useState(null);

  const [uploadResult, setUploadResult] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState("upload");
 
  const token = localStorage.getItem("bgc_token");
 
  const { getRootProps, getInputProps, isDragActive } = useDropzone({

    onDrop: (acceptedFiles) => {

      if (acceptedFiles.length > 0) {

        setSelectedFile(acceptedFiles[0]);

        setUploadResult(null);

      }

    },

    multiple: false,

  });
 
  const cleanText = (text) => {

    if (!text) return "N/A";

    return text.replace(/\u0000/g, "").replace(/[^\x20-\x7E]+/g, " ").trim();

  };
 
  const handleUpload = async () => {

    if (!selectedFile) {

      alert("Please select a file to upload.");

      return;

    }
 
    const formData = new FormData();

    formData.append("file", selectedFile);

    formData.append("documentType", "general");

    formData.append("enableAdvancedAnalysis", true);

    formData.append("extractMetadata", true);

    formData.append("performImageAnalysis", true);
 
    try {

      setLoading(true);

      setError(null);
 
      const response = await axios.post(

        "https://trueface.co.in/api/employee/documents/analyze",

        formData,

        {

          headers: {

            "Content-Type": "multipart/form-data",

            Authorization: `Bearer ${token}`,

          },

        }

      );
 
      const cleanResult = {

        ...response.data,

        analysisDetails: {

          metadata: cleanText(response.data.analysisDetails?.metadata),

          imageAnalysis: cleanText(response.data.analysisDetails?.imageAnalysis),

          documentAnalysis: cleanText(

            response.data.analysisDetails?.documentAnalysis

          ),

          aiAnalysis: cleanText(response.data.analysisDetails?.aiAnalysis),

        },

      };
 
      setUploadResult(cleanResult);

      setActiveTab("report");

    } catch (err) {

      console.error("Upload failed:", err);

      setError(err.response?.data || "Something went wrong while uploading.");

    } finally {

      setLoading(false);

    }

  };
 
  const handleReset = () => {

    setSelectedFile(null);

    setUploadResult(null);

    setError(null);

    setActiveTab("upload");

  };
 
  /** === PDF DOWNLOAD WITHOUT CONFIDENCE SCORE / DOCUMENT TYPE === */

  const handleDownloadPDF = () => {

    if (!uploadResult) return;
 
    const doc = new jsPDF();

    doc.setFont("helvetica");

    let y = 20;
 
    doc.setFontSize(16);

    doc.text("Document Analysis Report", 14, y);

    y += 10;
 
    doc.setFontSize(12);

    const statusText = uploadResult.isForgery

      ? "Status: Forged Document"

      : "Status: Genuine Document";

    doc.text(statusText, 14, y);

    y += 10;
 
    autoTable(doc, {

      startY: y,

      head: [["Field", "Value"]],

      body: [

        ["File Name", uploadResult.filename || "N/A"],

        [

          "Created At",

          uploadResult.createdAt

            ? new Date(uploadResult.createdAt).toLocaleString()

            : "N/A",

        ],

        ["Forgery Status", uploadResult.isForgery ? "Forged" : "Genuine"],

      ],

      theme: "grid",

      headStyles: {

        fillColor: [102, 205, 170],

        halign: "center",

        textColor: 255,

        fontStyle: "bold",

      },

      bodyStyles: { halign: "left" },

    });
 
    y = doc.lastAutoTable.finalY + 10;
 
    const details = [

      { title: "Metadata Analysis", content: uploadResult.analysisDetails?.metadata },

      { title: "Image Analysis", content: uploadResult.analysisDetails?.imageAnalysis },

      { title: "Document Analysis", content: uploadResult.analysisDetails?.documentAnalysis },

      { title: "AI Analysis", content: uploadResult.analysisDetails?.aiAnalysis },

    ];
 
    autoTable(doc, {

      startY: y,

      head: [["Analysis Type", "Details"]],

      body: details.map((d) => [d.title, d.content]),

      theme: "grid",

      headStyles: {

        fillColor: [255, 165, 0],

        halign: "center",

        textColor: 255,

        fontStyle: "bold",

      },

      columnStyles: {

        0: { cellWidth: 50 },

        1: { cellWidth: 130 },

      },

      bodyStyles: { valign: "top", fontSize: 10 },

      styles: { overflow: "linebreak", cellPadding: 3 },

    });
 
    doc.save(`Document_Report_${uploadResult.filename || "report"}.pdf`);

  };
 
  return (
<div className="emp-dashboard-container">
<Sidebar />
<div className="emp-main-panel">
<TopNavbar />
 
        <div className="doc-upload-container">
<div className="doc-upload-card">
<h2>📄 Document Forgery Detection</h2>
 
            {/* Upload Tab */}

            {activeTab === "upload" && (
<div className="upload-tab">
<div

                  {...getRootProps()}

                  className={`dropzone ${isDragActive ? "active" : ""}`}
>
<input {...getInputProps()} />

                  {selectedFile ? (
<p>📂 {selectedFile.name}</p>

                  ) : (
<p>Drag & drop a file here or click to browse</p>

                  )}
</div>
 
                {selectedFile && (
<div className="preview-section">
<h4>Preview:</h4>
<img

                      src={URL.createObjectURL(selectedFile)}

                      alt="Preview"

                      className="preview-image"

                    />
</div>

                )}
 
                <div className="button-group">
<button

                    onClick={handleUpload}

                    className="btn start-btn"

                    disabled={!selectedFile || loading}
>

                    {loading ? "Analyzing..." : "Start Analysis"}
</button>
<button onClick={handleReset} className="btn reset-btn">

                    Reset
</button>
</div>
</div>

            )}
 
            {/* Report Tab */}

            {activeTab === "report" && uploadResult && (
<div

                className={`report-preview ${

                  uploadResult.isForgery ? "forgery" : "genuine"

                }`}
>
<h3>📊 Document Analysis Report</h3>
<h4>{uploadResult.isForgery ? "Forged Document" : "Genuine Document"}</h4>
 
                <table className="analysis-table">
<tbody>
<tr>
<th>File Name</th>
<td>{uploadResult.filename || "N/A"}</td>
</tr>
 
                    {/* REMOVED Confidence Score */}
 
                    {/* REMOVED Document Type */}
 
                    <tr>
<th>Created At</th>
<td>

                        {uploadResult.createdAt

                          ? new Date(uploadResult.createdAt).toLocaleString()

                          : "N/A"}
</td>
</tr>
 
                    <tr>
<th>Forgery Status</th>
<td>{uploadResult.isForgery ? "Forged" : "Genuine"}</td>
</tr>
</tbody>
</table>
 
                <h4>🔍 Detailed Analysis</h4>
<table className="analysis-table">
<tbody>
<tr>
<th>🧾 Metadata Analysis</th>
<td>{uploadResult.analysisDetails?.metadata}</td>
</tr>
<tr>
<th>🖼️ Image Analysis</th>
<td>{uploadResult.analysisDetails?.imageAnalysis}</td>
</tr>
<tr>
<th>📄 Document Analysis</th>
<td>{uploadResult.analysisDetails?.documentAnalysis}</td>
</tr>
<tr>
<th>🤖 AI Analysis</th>
<td>
<pre className="ai-analysis">

                          {uploadResult.analysisDetails?.aiAnalysis}
</pre>
</td>
</tr>
</tbody>
</table>
 
                <div className="button-group">
<button className="btn download-btn" onClick={handleDownloadPDF}>

                    📥 Download PDF Report
</button>
 
                  <button className="btn reset-btn" onClick={handleReset}>

                    Back to Upload
</button>
</div>
</div>

            )}
</div>
</div>
 
        {error && <div className="error-msg">❌ {error}</div>}
</div>
</div>

  );

};
 
export default DocumentUpload;

 